import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
import {Actions as CREATEACCOUNTACTIONS} from '../store/actions/createAccountActions';

import testimonialPhoto from '../assets/images/figolli/Chris-Deeson.webp';
import testimonialPhoto2 from '../assets/images/figolli/rod-figolla.jpeg';
import buddyFigollaBakedStack from '../assets/images/figolli/buddy-figolla-baked-stack.jpeg';
import buddyFigollaCutting from '../assets/images/figolli/buddy-figolla-cutting.jpeg';
import buddyFigollaFilling from '../assets/images/figolli/buddy-figolla-filling.jpeg';
import buddyFigollaPackedSample from '../assets/images/figolli/buddy-figolla-packed-sample.jpeg';
import buddyFigollaPreBake from '../assets/images/figolli/buddy-figolla-pre-bake.jpeg';
import buddyFigollaSandwichFilling from '../assets/images/figolli/buddy-figolla-sandwich-filling.jpeg';
import buddyFigollaSplit1 from '../assets/images/figolli/buddy-figolla-split-1.jpeg';
import buddyFigollaSplit2 from '../assets/images/figolli/buddy-figolla-split-2.jpeg';
import buddyFigollaFinishing from '../assets/images/figolli/buddy-figolli-finishing.jpeg';
import buddyFigollaPackaged from '../assets/images/figolli/buddy-figolli-packaged.jpeg';
import buddyFigollaFun from '../assets/images/figolli/buddy-figolla-fun.jpeg';

// founding timeline
/*const timeline = [
  {
    name: 'Founded company',
    description:
      'Buddy Limited, was officially founded in Malta, starting operations with a handful of paying clients.',
    date: 'Jun 2018',
    dateTime: '2018-06',
  },
  {
    name: 'First Payroll Bureau Client',
    description:
      'Buddy enrolled its very first Accounting Firm / Payroll Bureau as a client in 2019, going on to become a local leader in the sector.',
    date: 'Jan 2019',
    dateTime: '2019-01',
  },
  {
    name: 'UK Expansion Plan',
    description:
      'The co-founders agree that the first country to expand into, outside of Malta, will be the United Kingdom. And together hatch a plan to start working towards that growth.',
    date: 'Dec 2020',
    dateTime: '2020-12',
  },
  {
    name: 'UK Edition Available',
    description:
      'Following, years of research, networking and product development, finally the expected public release date of Buddy UK Edition is only months away.',
    date: 'Jul 2023',
    dateTime: '2023-07',
  },
]*/

// founding timeline
const timeline = [
  {
    name: 'Figolli Plan Hatched',
    description:
      "Wanting something that representing Maltese culture, and that cannot be found in the UK, and that would represent Buddy's brand in the UK, the team set their sights to make Buddy-branded Figolli.",
    date: 'Mar 2023',
    dateTime: '2018-03',  
  },
  {
    name: 'The Moulds',
    description:
      "Being such a unique brand; one couldn't simply find ready-made shapes for our custom baking projects. We embarked on a custom 3D-Printed cookie-cutter with 3D Invent.",
    date: ' Apr 2023',
    dateTime: '2023-04',
  },
  {
    name: 'The Bake',
    description:
      "Master Baker, Sarah, also our CTO's PA, assisted by Rachel took charge of the initial cookie cutting and Bake. Baking over a 100 cookies in a span of a few hours.",
    date: 'T- 2 days',
    dateTime: '2023-05',
  },
  {
    name: 'The Finishing Touches',
    description:
      'Once cooled, the batch of 100 figolli, moved to our offices in Marsa, Malta for a team effort to get the whole batch decorated up to our high standards.',
    date: 'T- 1 day',
    dateTime: '2023-05',
  },
  // {
  //   name: 'The Delivery',
  //   description:
  //     'The packaged valuables were entrusted to our Co-Founders, David & Jon to deliver each and every one of these to you.',
  //   date: 'T- 1 hour',
  //   dateTime: '2023-07',
  // },
]

const stats = [
  {
    label: "Colours",
    value: 3 
  },
  {
    label: "Pieces",
    value: 9 
  },
  {
    label: "Team Members",
    value: 12 
  },
  {
    label: "Figolli",
    value: 100 
  },
]

const figolliHighlights = [
  {
    name: 'The Assembly Line',
    description: [
      'Putting together these Figolli meant each piece being hand-cut, segregated from the sugar paste sheets, and carefully placed onto the underlying figolla base.',
      'Each figolla passed through a quality control process, where details, such as the positioning of the eyes were thourhly check to ensure they were up to standard.',
      "It's also fair to say, that quite a few vanished throughout the quality control process...",
    ],
    imageSrc: 'https://player.vimeo.com/video/824412163?h=a2f11aefbf&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    imageAlt: 'White canvas laptop sleeve with gray felt interior, silver zipper, and tan leather zipper pull.',
  },
  {
    name: 'Finishing Touches',
    description:[
      'Once the Figolli were all complete, they had to undergo one final process.',
      'Cleaning and removing of any excess sugar paste, that appeared through the cutting of the fine details. Including any minor adjustments by hand.',
      'Finally, they were individually packaged with a personalised signature from the team member who sealed the final package.',
      "If you're lucky you'll be able to get some signed by our co-Founders David and Jonathan, which are guaranteed to be collectables.",
    ],
    imageSrc: 'https://player.vimeo.com/video/824412905?h=d67ef27c43&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    imageAlt: 'Detail of zipper pull with tan leather and silver rivet.',
  },
]


const people = [
  {
    name: 'Chris Deeson',
    role: 'COO of LitE Consulting Ltd',
    imageUrl: testimonialPhoto,
    bio: "Didn't last long once I got it back home!",
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Roderick Schneider',
    role: 'COO of Workforce.com',
    imageUrl: testimonialPhoto2,
    bio: "I only got to take the photo! The team left no traces by the time I got back to the office.",
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  // More people...
]


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function Figolli({
  addTag
}) {

  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  return (

    <React.Fragment>

      <Helmet>
          <title>Figolla - the Maltese Traditional sweet | Buddy</title>
          <meta name="description" content="Your Buddy figolla, made with love by the team, live the figolli experience." />
          <link rel="canonical" href={`https://www.buddy.hr/uk/figolla`} />
          <html lang="en-GB" amp />
      </Helmet>

      {/* HEADER */}
      <main className='bg-white'>
        <div className="relative isolate">
          <div
            className="absolute left-1/2 right-0 top-0 -z-10 -ml-24 transform-gpu overflow-hidden blur-3xl lg:ml-24 xl:ml-48"
            aria-hidden="true"
          >
            <div
              className="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-[#ea611c] to-[#9089fc] opacity-10"
              style={{
                clipPath:
                  'polygon(63.1% 29.5%, 100% 17.1%, 76.6% 3%, 48.4% 0%, 44.6% 4.7%, 54.5% 25.3%, 59.8% 49%, 55.2% 57.8%, 44.4% 57.2%, 27.8% 47.9%, 35.1% 81.5%, 0% 97.7%, 39.2% 100%, 35.2% 81.4%, 97.2% 52.8%, 63.1% 29.5%)',
              }}
            />
          </div>
          <div className="overflow-hidden">
            <div className="mx-auto max-w-7xl px-6 pb-32 pt-36 sm:pt-60 lg:px-8 lg:pt-32">
              <div className="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
                <div className="w-full max-w-xl lg:shrink-0 xl:max-w-2xl">
                  <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                    Figolla
                  </h1>
                  <p className="relative mt-6 text-lg leading-8 text-gray-600 sm:max-w-md lg:max-w-none">
                    A traditional Maltese sweet, the Figolla (singular) dates back thousands of years with roots in Pagan history. 
                    Today, it is most commonly found during easter-time as a traditional snack.
                    Hijacked by the Buddy team, to take a piece of home, away from home.
                  </p>
                  <p className="relative mt-6 text-lg leading-8 text-gray-600 sm:max-w-md lg:max-w-none">
                    Join us, in the journey of the Buddy Figolli (plural). From conception to the team effort to have them personally delivered to you.
                  </p>
                  {/*<div className="mt-10 flex items-center gap-x-6">
                                      <a
                                        href="#"
                                        className="rounded-md bg-orange-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                                      >
                                        Get started
                                      </a>
                                      <a href="#" className="text-sm font-semibold leading-6 text-gray-900">
                                        Live demo <span aria-hidden="true">→</span>
                                      </a>
                                    </div>*/}
                </div>
                <div className="mt-14 flex justify-end gap-8 sm:-mt-44 sm:justify-start sm:pl-20 lg:mt-0 lg:pl-0">
                  <div className="ml-auto w-44 flex-none space-y-8 pt-32 sm:ml-0 sm:pt-80 lg:order-last lg:pt-36 xl:order-none xl:pt-80">
                    <div className="relative">
                      <img
                        src={buddyFigollaSplit2}
                        alt=""
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                  </div>
                  <div className="mr-auto w-44 flex-none space-y-8 sm:mr-0 sm:pt-52 lg:pt-36">
                    <div className="relative">
                      <img
                        src={buddyFigollaFun}
                        alt=""
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover object-top shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                    <div className="relative">
                      <img
                        src={buddyFigollaCutting}
                        alt=""
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                  </div>
                  <div className="w-44 flex-none space-y-8 pt-32 sm:pt-0">
                    <div className="relative">
                      <img
                        src={buddyFigollaFinishing}
                        alt=""
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                    <div className="relative">
                      <img
                        src={buddyFigollaPackaged}
                        alt=""
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      

      {/* TIMELINE */}
      <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-8 overflow-hidden lg:mx-0 lg:max-w-none lg:grid-cols-4">
            {timeline.map((item) => (
              <div key={item.name}>
                <time
                  dateTime={item.dateTime}
                  className="flex items-center text-sm font-semibold leading-6 text-orange-600"
                >
                  <svg viewBox="0 0 4 4" className="mr-4 h-1 w-1 flex-none" aria-hidden="true">
                    <circle cx={2} cy={2} r={2} fill="currentColor" />
                  </svg>
                  {item.date}
                  <div
                    className="absolute -ml-2 h-px w-screen -translate-x-full bg-gray-300 sm:-ml-4 lg:static lg:-mr-6 lg:ml-8 lg:w-auto lg:flex-auto lg:translate-x-0"
                    aria-hidden="true"
                  />
                </time>
                <p className="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900">{item.name}</p>
                <p className="mt-1 text-base leading-7 text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* TEAM */}
      <div className="overflow-hidden bg-white py-32">
        <div className="mx-auto max-w-7xl px-6 lg:flex lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:min-w-full lg:max-w-none lg:flex-none lg:gap-y-8">
            <div className="lg:col-end-1 lg:w-full lg:max-w-lg lg:pb-8">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">What's Inside?</h2>
              <p className="mt-6 text-xl leading-8 text-gray-600">
                A soft almond filling, sandwiched between two lemon and orange flavoured biscuits.
                Covered with Buddy branded royal icing.
              </p>
              <p className="mt-6 text-xl leading-8 text-gray-600">
                No better way to bring joy to your payroll experience.
              </p>
              <p className="mt-6 text-base leading-7 text-gray-600">
                <strong>Ingredients:</strong> Flour, Butter, Vanilla Essence, Eggs, Milk, Almonds, Almond Essence, Lemon, Oranges, Gelatine, Glucose, Glycerin, Shortening, Icing Sugar, Food Colouring 
              </p>
              <p className="mt-6 text-sm leading-7 text-gray-600">
                <strong>Allergens:</strong> Kindly note the ingredients, as Figolli contain nuts (Almonds) and other allergens.
              </p>
              {/*<div className="mt-10 flex">
                <a
                  href="#"
                  className="rounded-md bg-orange-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                >
                  Join our team <span aria-hidden="true">&rarr;</span>
                </a>
              </div>*/}
            </div>
            <div className="flex flex-wrap items-start justify-end gap-6 sm:gap-8 lg:contents">
              <div className="w-0 flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end">
                <img
                  src={buddyFigollaSplit1}
                  alt=""
                  className="aspect-[7/5] w-[37rem] max-w-none rounded-2xl bg-gray-50 object-cover"
                />
              </div>
              <div className="contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-[37rem] lg:items-start lg:justify-end lg:gap-x-8">
                <div className="order-first flex w-64 flex-none justify-end self-end lg:w-auto">
                  <img
                    src={buddyFigollaPreBake}
                    alt=""
                    className="aspect-[4/3] w-[24rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover"
                  />
                </div>
                <div className="flex w-96 flex-auto justify-end lg:w-auto lg:flex-none">
                  <img
                    src={buddyFigollaSandwichFilling}
                    alt=""
                    className="aspect-[7/5] w-[37rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover"
                  />
                </div>
                <div className="hidden sm:block sm:w-0 sm:flex-auto lg:w-auto lg:flex-none">
                  <img
                    src={buddyFigollaBakedStack}
                    alt=""
                    className="aspect-[4/3] w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* VERTICAL BLOCK */}
      <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-16 sm:gap-y-24 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <div className="lg:pr-4">
                <div class="max-w-sm  mx-auto">
                  <div class="aspect-w-9 aspect-h-16 rounded-3xl overflow-hidden">
                    <iframe src="https://player.vimeo.com/video/824412436?h=c81136527f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </div>
            </div>
            <div>
              <div className="text-base leading-7 text-gray-700 lg:max-w-lg">
                <p className="text-base font-semibold leading-7 text-orange-600">The Team in Action</p>
                <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                  All hands on-deck
                </h2>
                <div className="max-w-xl">
                  <p className="mt-6">
                    Decorating 100 Figolli was no mean feat, that meant we needed all hand on decks.
                    Our founders, their incredible assistants, the marketing team and the development team were all in our office boardroom.
                    The only team that was allowed to actually work, was our support team, who amazingly kept the fort mid-payroll week all by themselves.
                  </p>
                  <p className="mt-8">
                    The process of decorating your Figolla, requires an intricate number of steps, from three different colours of sugar paste and nine (9), yes nine different stencil cuts.
                    In order to get these done our team assembed in units, that looked just like a challenge from Overcooked 2.
                    With responsabilities varying from rolling the sugar paste; cutting; assembly; packaging and delivery.
                  </p>
                  <p className="mt-8">
                    There's no better way than understanding what makes up a team, than seeing them work under pressure to deliver in a tight deadline.
                    Sharing our Figolli-making team session, lets you see all this in a couple of minutes. (watch video)
                  </p>
                </div>
              </div>
              <dl className="mt-10 grid grid-cols-2 gap-8 border-t border-gray-900/10 pt-10 sm:grid-cols-4">
                {stats.map((stat, statIdx) => (
                  <div key={statIdx}>
                    <dt className="text-sm font-semibold leading-6 text-gray-600">{stat.label}</dt>
                    <dd className="mt-2 text-3xl font-bold leading-10 tracking-tight text-gray-900">{stat.value}</dd>
                  </div>
                ))}
              </dl>
              {/*<div className="mt-10 flex">
                <a href="#" className="text-base font-semibold leading-7 text-orange-600">
                  Learn more about our company <span aria-hidden="true">&rarr;</span>
                </a>
              </div>*/}
            </div>
          </div>
        </div>
      </div>


    <div className="bg-white">
      <div className="mx-auto max-w-2xl px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">The Little Details</h2>
        </div>

        <div className="mt-16 space-y-16">
          {figolliHighlights.map((feature, featureIdx) => (
            <div
              key={feature.name}
              className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center lg:gap-x-8"
            >
              <div
                className={classNames(
                  featureIdx % 2 === 0 ? 'lg:col-start-1' : 'lg:col-start-8 xl:col-start-9',
                  'mt-6 lg:col-span-5 lg:row-start-1 lg:mt-0 xl:col-span-4'
                )}
              >
                <h3 className="text-lg font-medium text-gray-900">{feature.name}</h3>
                {feature.description.map(p => 
                  <p className="mt-2 text-sm text-gray-500">{p}</p>
                )}
                
              </div>
              <div
                className={classNames(
                  featureIdx % 2 === 0 ? 'lg:col-start-6 xl:col-start-5' : 'lg:col-start-1',
                  'flex-auto lg:col-span-7 lg:row-start-1 xl:col-span-8'
                )}
              >
                <div className="aspect-w-16 aspect-h-9 overflow-hidden rounded-lg bg-gray-100">
                  <iframe src={feature.imageSrc} alt={feature.imageAlt} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    <div className="bg-white py-24 md:py-32 lg:py-40">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-x-8 gap-y-20 px-6 lg:px-8 xl:grid-cols-3">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Testimonials</h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Don't trust us, on the sheer goodness of these Figolli. These people have already tasted them, see what they had to say.
          </p>
        </div>
        <ul
          role="list"
          className="mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-20 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:gap-x-8 xl:col-span-2"
        >
          {people.map((person) => (
            <li key={person.name}>
              <div className="aspect-[3/2] w-full rounded-2xl mx-auto flex max-w-7xl flex-col items-center gap-x-8 gap-y-10 px-6 sm:gap-y-8 lg:px-8 xl:flex-row xl:items-stretch relative">
               
                  
                    <img
                      className="absolute inset-0 h-full w-full rounded-2xl bg-gray-800 object-cover shadow-2xl brightness-50"
                      src={person.imageUrl}
                      alt={person.name}
                    />
                  
                <div className="w-full max-w-2xl xl:max-w-none xl:flex-auto xl:px-4 xl:py-12">
                  <figure className="isolate pt-6 sm:pt-12">
                    <svg
                      viewBox="0 0 162 128"
                      fill="none"
                      aria-hidden="true"
                      className="absolute left-0 top-0 -z-10 h-24 stroke-white/20"
                    >
                      <path
                        id="b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb"
                        d="M65.5697 118.507L65.8918 118.89C68.9503 116.314 71.367 113.253 73.1386 109.71C74.9162 106.155 75.8027 102.28 75.8027 98.0919C75.8027 94.237 75.16 90.6155 73.8708 87.2314C72.5851 83.8565 70.8137 80.9533 68.553 78.5292C66.4529 76.1079 63.9476 74.2482 61.0407 72.9536C58.2795 71.4949 55.276 70.767 52.0386 70.767C48.9935 70.767 46.4686 71.1668 44.4872 71.9924L44.4799 71.9955L44.4726 71.9988C42.7101 72.7999 41.1035 73.6831 39.6544 74.6492C38.2407 75.5916 36.8279 76.455 35.4159 77.2394L35.4047 77.2457L35.3938 77.2525C34.2318 77.9787 32.6713 78.3634 30.6736 78.3634C29.0405 78.3634 27.5131 77.2868 26.1274 74.8257C24.7483 72.2185 24.0519 69.2166 24.0519 65.8071C24.0519 60.0311 25.3782 54.4081 28.0373 48.9335C30.703 43.4454 34.3114 38.345 38.8667 33.6325C43.5812 28.761 49.0045 24.5159 55.1389 20.8979C60.1667 18.0071 65.4966 15.6179 71.1291 13.7305C73.8626 12.8145 75.8027 10.2968 75.8027 7.38572C75.8027 3.6497 72.6341 0.62247 68.8814 1.1527C61.1635 2.2432 53.7398 4.41426 46.6119 7.66522C37.5369 11.6459 29.5729 17.0612 22.7236 23.9105C16.0322 30.6019 10.618 38.4859 6.47981 47.558L6.47976 47.558L6.47682 47.5647C2.4901 56.6544 0.5 66.6148 0.5 77.4391C0.5 84.2996 1.61702 90.7679 3.85425 96.8404L3.8558 96.8445C6.08991 102.749 9.12394 108.02 12.959 112.654L12.959 112.654L12.9646 112.661C16.8027 117.138 21.2829 120.739 26.4034 123.459L26.4033 123.459L26.4144 123.465C31.5505 126.033 37.0873 127.316 43.0178 127.316C47.5035 127.316 51.6783 126.595 55.5376 125.148L55.5376 125.148L55.5477 125.144C59.5516 123.542 63.0052 121.456 65.9019 118.881L65.5697 118.507Z"
                      />
                      <use href="#b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb" x={86} />
                    </svg>
                    <blockquote className="text-xl font-semibold leading-7 text-white">
                      <p>
                        {person.bio}
                      </p>
                    </blockquote>
                    <figcaption className="mt-4 text-base">
                      <div className="font-semibold text-white">{person.name}</div>
                      <div className="mt-0 text-gray-100">{person.role}</div>
                    </figcaption>
                  </figure>
                </div>
              </div>
              {/*<ul role="list" className="mt-6 flex gap-x-6">
                <li>
                  <a href={person.twitterUrl} className="text-gray-400 hover:text-gray-500">
                    <span className="sr-only">Twitter</span>
                    <svg className="h-5 w-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href={person.linkedinUrl} className="text-gray-400 hover:text-gray-500">
                    <span className="sr-only">LinkedIn</span>
                    <svg className="h-5 w-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fillRule="evenodd"
                        d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </a>
                </li>
              </ul>*/}
            </li>
          ))}
        </ul>
      </div>
    </div>


      {/* TESTIMONIAL */}
      {/*<div className="bg-white pb-16 pt-24 sm:pb-24 sm:pt-32 xl:pb-32">
              <div className="bg-gray-900 pb-20 sm:pb-24 xl:pb-0">
                <div className="mx-auto flex max-w-7xl flex-col items-center gap-x-8 gap-y-10 px-6 sm:gap-y-8 lg:px-8 xl:flex-row xl:items-stretch">
                  <div className="-mt-8 w-full max-w-2xl xl:-mb-8 xl:w-96 xl:flex-none">
                    <div className="relative aspect-[2/1] h-full md:-mx-8 xl:mx-0 xl:aspect-auto">
                      <img
                        className="absolute inset-0 h-full w-full rounded-2xl bg-gray-800 object-cover shadow-2xl"
                        src={testimonialPhoto}
                        alt="Chris Deeson"
                      />
                    </div>
                  </div>
                  <div className="w-full max-w-2xl xl:max-w-none xl:flex-auto xl:px-16 xl:py-24">
                    <figure className="relative isolate pt-6 sm:pt-12">
                      <svg
                        viewBox="0 0 162 128"
                        fill="none"
                        aria-hidden="true"
                        className="absolute left-0 top-0 -z-10 h-32 stroke-white/20"
                      >
                        <path
                          id="b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb"
                          d="M65.5697 118.507L65.8918 118.89C68.9503 116.314 71.367 113.253 73.1386 109.71C74.9162 106.155 75.8027 102.28 75.8027 98.0919C75.8027 94.237 75.16 90.6155 73.8708 87.2314C72.5851 83.8565 70.8137 80.9533 68.553 78.5292C66.4529 76.1079 63.9476 74.2482 61.0407 72.9536C58.2795 71.4949 55.276 70.767 52.0386 70.767C48.9935 70.767 46.4686 71.1668 44.4872 71.9924L44.4799 71.9955L44.4726 71.9988C42.7101 72.7999 41.1035 73.6831 39.6544 74.6492C38.2407 75.5916 36.8279 76.455 35.4159 77.2394L35.4047 77.2457L35.3938 77.2525C34.2318 77.9787 32.6713 78.3634 30.6736 78.3634C29.0405 78.3634 27.5131 77.2868 26.1274 74.8257C24.7483 72.2185 24.0519 69.2166 24.0519 65.8071C24.0519 60.0311 25.3782 54.4081 28.0373 48.9335C30.703 43.4454 34.3114 38.345 38.8667 33.6325C43.5812 28.761 49.0045 24.5159 55.1389 20.8979C60.1667 18.0071 65.4966 15.6179 71.1291 13.7305C73.8626 12.8145 75.8027 10.2968 75.8027 7.38572C75.8027 3.6497 72.6341 0.62247 68.8814 1.1527C61.1635 2.2432 53.7398 4.41426 46.6119 7.66522C37.5369 11.6459 29.5729 17.0612 22.7236 23.9105C16.0322 30.6019 10.618 38.4859 6.47981 47.558L6.47976 47.558L6.47682 47.5647C2.4901 56.6544 0.5 66.6148 0.5 77.4391C0.5 84.2996 1.61702 90.7679 3.85425 96.8404L3.8558 96.8445C6.08991 102.749 9.12394 108.02 12.959 112.654L12.959 112.654L12.9646 112.661C16.8027 117.138 21.2829 120.739 26.4034 123.459L26.4033 123.459L26.4144 123.465C31.5505 126.033 37.0873 127.316 43.0178 127.316C47.5035 127.316 51.6783 126.595 55.5376 125.148L55.5376 125.148L55.5477 125.144C59.5516 123.542 63.0052 121.456 65.9019 118.881L65.5697 118.507Z"
                        />
                        <use href="#b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb" x={86} />
                      </svg>
                      <blockquote className="text-xl font-semibold leading-8 text-white sm:text-2xl sm:leading-9">
                        <p>
                          Didn't last long once I got it back home!
                        </p>
                      </blockquote>
                      <figcaption className="mt-8 text-base">
                        <div className="font-semibold text-white">Chris Deeson</div>
                        <div className="mt-1 text-gray-100">COO of LitE Consulting Ltd</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>*/}

      <div className="bg-white py-16 sm:py-24">
        <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="relative isolate flex flex-col gap-10 overflow-hidden bg-gray-900 px-6 py-24 shadow-2xl sm:rounded-3xl sm:px-24 xl:flex-row xl:items-center xl:py-32">
            <div className="max-w-2xl sm:text-4xl xl:max-w-none xl:flex-auto">
              <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl xl:max-w-none xl:flex-auto">
                Follow our Story.
              </h2>
              <p className="mt-4 text-sm leading-6 text-gray-300">
                As we break into the UK HR & Payroll Market
              </p>
            </div>
            <form className="w-full max-w-md">
              {!subscribed &&
                <div className="flex gap-x-4">
                  <label htmlFor="email-address" className="sr-only">
                    Email address
                  </label>
                  <input
                    id="email-address"
                    name="email"
                    type="email"
                    autoComplete="email"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="min-w-0 flex-auto rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-white sm:text-sm sm:leading-6"
                    placeholder="Enter your email"
                  />
                  <button
                    type="submit"
                    className="flex-none rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                    onClick={async () => {
                      await addTag({
                        email: email,
                        tag: 173
                      })
                      setSubscribed(true)
                    }}
                  >
                    Update me
                  </button>
                </div>
              }
              {subscribed &&
                <p className="mt-4 text-sm leading-6 text-gray-300">
                  We've got your details, we'll keep you updated with our Journey.
                </p>
              }
              <p className="mt-4 text-sm leading-6 text-gray-300">
                We care about your data. Read our{' '}
                <a href="/terms" className="font-semibold text-white">
                  privacy&nbsp;policy
                </a>
                .
              </p>
            </form>
            <svg
              viewBox="0 0 1024 1024"
              className="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2"
              aria-hidden="true"
            >
              <circle cx={512} cy={512} r={512} fill="url(#759c1415-0410-454c-8f7c-9a820de03641)" fillOpacity="0.7" />
              <defs>
                <radialGradient
                  id="759c1415-0410-454c-8f7c-9a820de03641"
                  cx={0}
                  cy={0}
                  r={1}
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(512 512) rotate(90) scale(512)"
                >
                  <stop stopColor="#ea611c" />
                  <stop offset={1} stopColor="#E935C1" stopOpacity={0} />
                </radialGradient>
              </defs>
            </svg>
          </div>
        </div>
      </div>


    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),

  addTag: (data) => dispatch(CREATEACCOUNTACTIONS.addTag(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Figolli) 
